import React from 'react';
import { Loader2 } from 'lucide-react';

import { cn } from '../lib/utils';

interface SpinnerIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export const Spinner: React.FC<SpinnerIconProps> = ({
  size = 9,
  className,
  ...props
}) => {
  return (
    <Loader2 {...props} size={size} className={cn('animate-spin', className)} />
  );
};
